import React from "react";
import { useState, useEffect } from "react";
import { FormDiv } from "./Form.styled.js";
import { developAxios } from "../../axios.config.js";
import { useHistory } from "react-router-dom";
import {
	NotificationContainer,
	NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { FormControlLabel, Switch } from "@mui/material";

const FormUpload = () => {
	const [heading, setHeading] = useState("");
	const [headingLogo, setHeadingLogo] = useState("");
	const [isChecked, setIsChecked] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [course, setCourse] = useState([]);
	const [selectedCourse, setSelectedCourse] = useState(undefined);

	const history = useHistory();

	useEffect(() => {
		let params = new URLSearchParams(window.location.search);
		let courseId = params.get("course");

		if (!courseId) {
			history.push("/video-upload");
			return;
		} else {
			setSelectedCourse(courseId);
		}
	}, []);

	let handleSubmit = (e) => {
		e.preventDefault();

		developAxios(localStorage.getItem("token"))
			.post(`/update-learning-data/${selectedCourse}`, {
				learning: {
					heading: heading,
					headingLogo: headingLogo,
					content: [],
					locked: isChecked,
				},
			})
			.then(({ data }) => {
				setIsSubmitted(true);
				NotificationManager.success("Data is Submited", "sucess");
			})
			.catch((e) => {
				setIsSubmitted(false);
				NotificationManager.error(
					"Please Try Again something Went Wrong",
					"error"
				);
			});
	};

	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/getallCourse")
			.then(({ data }) => {
				setCourse(
					data.courses.map((item) => {
						return {
							value: item._id,
							label: item.name,
						};
					})
				);
			});
	}, []);

	return (
		<>
			{" "}
			<NotificationContainer />
			<FormDiv>
				<div class="container">
					<form id="contact" onSubmit={handleSubmit}>
						<h3>Upload Content</h3>
						<label> Heading Logo</label>
						<fieldset>
							<input
								placeholder="HeadingLogo"
								type="text"
								tabindex="3"
								name="HeadingLogo"
								required
								value={headingLogo}
								onChange={(e) => setHeadingLogo(e.target.value)}
							/>{" "}
						</fieldset>
						<label>Heading</label>
						<fieldset>
							<input
								placeholder="heading"
								type="text"
								tabindex="3"
								name="heading"
								required
								value={heading}
								onChange={(e) => setHeading(e.target.value)}
							/>{" "}
						</fieldset>
						<fieldset>
							<FormControlLabel
								control={
									<Switch
										value={isChecked}
										onChange={() =>
											setIsChecked((val) => !val)
										}
									/>
								}
								label="Lock the Course"
								labelPlacement="start"
							/>
						</fieldset>
						<fieldset>
							<button name="submit" type="submit" id="upload">
								Create
							</button>
						</fieldset>
					</form>
				</div>
			</FormDiv>
		</>
	);
};

export default FormUpload;
